// extracted by mini-css-extract-plugin
export default {"registrationSuccessWrapper":"RegistrationSuccess_registrationSuccessWrapper__HjGmV","mailIcon":"RegistrationSuccess_mailIcon__Ui5PM"};